module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Dedication"
    }
  }, [_c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_vm._v("To the men of the Allied armies who served in North West Europe 1944-45")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("‘With stout hearts, and with enthusiasm for the contest, let us go forward to victory’"), _c('br'), _vm._v("Extract from General B L Montgomery’s personal message to all Allied soldiers on"), _c('br'), _vm._v("the eve of D-Day. ‘To be read out to all troops once embarked, June 1944’.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d597cf6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Dedication.vue
// module id = 63
// module chunks = 0